import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "../../../../stateManagement/redux"
import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useRef, useState } from 'react';
import ReportCard from "../../reports_viewer/cart_with_info/card";
import generatePDF, { Options } from 'react-to-pdf';
import { validateAndFormatNumber } from "../../../../stateManagement/redux/slices/gerencia_tecnica/auxiliarFunctions";
import { OriginalFlowUploadInterface, validationTypeEnum } from "../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { validateAndConvertFraction } from "../../../../shared/util/validateFunction";
import { projectList } from "../../../../shared/util/projectList";
import { UploadActivitiesModal } from "./uploadActivityModal";
import { delay } from "./fileRow";
import { StatesTabs } from "./statesTabs";
import { GeneralTab } from "./generalTab";
import { ActivitiesList } from "./activitiesList";
import { CartsList } from "./cartsList";
import { ButtonsTab } from "./buttonsTab";
import { errorResults, IerrorResult, Squads } from "./processFiles";
import { uploadConsolidatedActivities } from "../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { compareStringsAccentInsensitive } from "../../../../shared/util/compare";
import { checkErrors } from "./checkErros";
import { ProcessFiles } from "./processFiles";
import { getFormValidations, getGroupAssignedConfig, getListOfLocationsByProject } from "src/shared/util/requestDataServer";
import { ErrorList } from "./errorList";

interface Props {
    close: any,
    originalFlow: string,
    originalFlowSelected: any,
    excelFile: any,
    listOfLocations: any[],
    setLocations: any
    listOfUsers: any[]
}

export interface IActivityValidation {
    projectId: string,
    numberOfActivities: number,
    activeTaskId: string,
    executedDate?: Date,
    squadNumber: number,
    groupActivityId: string,
    originalFlow?: OriginalFlowUploadInterface,
}

interface IgroupAssignedField {
    id: string,
    name: string,
    code: string,
}

interface IgroupAssignedActivity {
    id: string,
    name: string,
    code: string,
}

interface IgroupAssignedConfig {
    field: IgroupAssignedField[],
    activity: IgroupAssignedActivity[],
}

interface IUserSortActivityToUpload {
    id: string,
    name: string
}

interface IVariableToSortActivityToUpload {
    id: string,
    name: string,
    value: string,
}

export interface ISortsActivitiesToUpload {
    fieldId: string,
    locationId: string,
    originFlowId: string,
    projectId: string,
    taskid: string,
    users: IUserSortActivityToUpload[],
    variables: IVariableToSortActivityToUpload[],
    groupAssigned: string,
}

export const UploadModal = ({ close, originalFlow, originalFlowSelected, excelFile, listOfLocations, setLocations, listOfUsers }: Props) => {


    const dispatch = useDispatch();

    const [validatingData, setValidatingData] = useState<IActivityValidation>({
        projectId: '',
        numberOfActivities: 0,
        activeTaskId: '',
        squadNumber: 0,
        groupActivityId: '',
    })

    const [squads, setSquads] = useState<Squads[]>([])

    const [filterStates, setFilterStates] = useState([
        { id: "summary", name: "Generalidades", amountElement: 0, active: true },
        { id: "activities", name: "Actividades", amountElement: 0, active: false },
        { id: "errors", name: "Errores", amountElement: 0, active: false },
        { id: "files", name: "Archivos", amountElement: 0, active: false },
    ])

    const [variablesToValidate, setvariablesToValidate] = useState<any[]>([])

    const [sortsActivities, setSortsActivities] = useState<any[]>([])

    const [sortActivitiesToUpload, setSortActivitiesToUpload] = useState<ISortsActivitiesToUpload[]>([])

    const [errors, setErrors] = useState<errorResults>({})

    const [groupAssignedConfig, setGroupAssignedConfig] = useState<IgroupAssignedConfig>()

    const [uploadTaskWithVariables, setUploadTaskWithVariables] = useState(false)

    useEffect(() => {
        if (originalFlowSelected?.name && originalFlowSelected?.name !== '') {
            getFormValidations(originalFlowSelected?.name, "uploadV2").then((data) => {
                setvariablesToValidate(data)
            })

            getGroupAssignedConfig().then((data) => {
                setGroupAssignedConfig(data)
            })
        }
    }, [originalFlow])

    useEffect(() => {
        if (validatingData?.projectId && validatingData?.projectId !== '') {

            const lastProjectId = listOfLocations[0]?.projectId

            if (lastProjectId !== validatingData?.projectId) {
                getListOfLocationsByProject(validatingData?.projectId).then((data) => {
                    const locations = data.map((location: any) => {
                        return {
                            ...location,
                            projectId: validatingData?.projectId
                        }
                    })
                    setLocations(locations)
                }).catch((error) => {
                    console.log(`[Error Request Locations]: ${error}`)
                })
            } else {
                setValidatingData({ ...validatingData, projectId: lastProjectId })
            }
        } else if (listOfLocations && listOfLocations.length > 0) {
            const lastProjectId = listOfLocations[0]?.projectId
            setValidatingData({ ...validatingData, projectId: lastProjectId })
        }
    }, [validatingData?.projectId])

    useEffect(() => {
        if (excelFile && variablesToValidate && listOfLocations) {
            ProcessFiles(excelFile, variablesToValidate, listOfLocations, validatingData, listOfUsers,originalFlowSelected).then(({ errors, sortActivities, usersFromActivities, totalNumberOfErrors }) => {
                setErrors(errors)
                setSortsActivities(sortActivities)
                if (usersFromActivities) {
                    setSquads(usersFromActivities)
                }
                const newTabs = [...filterStates]
                const newErrors = newTabs.findIndex(x => x.id === 'errors')
                if (newErrors !== -1) {
                    newTabs[newErrors].amountElement = totalNumberOfErrors
                    setFilterStates(newTabs)
                }
            })
        }
    }, [excelFile, variablesToValidate, listOfLocations, validatingData, listOfUsers])

    useEffect(() => {
        let fieldCode = '0'

        if (validatingData?.projectId && validatingData?.projectId !== '') {
            const field = groupAssignedConfig?.field.find((x) => x.id === validatingData?.projectId)
            if (field) {
                fieldCode = field.code.toString().padStart(1, '0')
            }
        }

        let activityCode = '0'
        if (originalFlowSelected.name && originalFlowSelected.name !== '') {
            const activity = groupAssignedConfig?.activity.find((x) => x.name === originalFlowSelected.name)
            if (activity) {
                activityCode = activity.code.toString().padStart(2, '0')
            }
        }

        let squadCode = validatingData.squadNumber.toString().padStart(1, '0')

        const groupActivityId = `${fieldCode}${activityCode}${squadCode}`

        setValidatingData({ ...validatingData, groupActivityId: groupActivityId, originalFlow: originalFlowSelected })

    }, [validatingData.projectId, validatingData.squadNumber, groupAssignedConfig])


    const handleOnChangeValidationData = (value: any, field: string,) => {
        setValidatingData({ ...validatingData, [field]: value })
    }

    const onClose = () => {
        close()
    }

    const onClickUploadActivities = () => {
        let errorNe001 = false

        Object.keys(errors).forEach((key: string) => {
            (errors[key] as any[]).forEach((e: any) => {
                if (e.error.includes('NE-001')) {
                    errorNe001 = true
                }
            })
        })

        let step = errorNe001 ? 'Validate NE001' : 'CheckWsMessage'

        const newSortActivitiesToUpload: ISortsActivitiesToUpload[] = []

        for (const act of sortsActivities) {
            const variables:IVariableToSortActivityToUpload[] = []

            const users = squads.find((s) => s.members === act['Ingenieros'])?.users||[]

            variablesToValidate.forEach((variable: any) => {
                if (act[variable.name] && variable.type==="variable") {
                    variables.push({
                        id: variable.id,
                        name: variable.name,
                        value: act[variable.name]
                    })
                }
            })

            const existVar = variables.findIndex((v: any) => v.id === "290aa7b7-299e-48e6-bcae-ad9e083c5cac")

            if (existVar !== -1) {
                variables[existVar].value = `${validatingData.squadNumber}`
            }else{
                variables.push({
                    id: "290aa7b7-299e-48e6-bcae-ad9e083c5cac",
                    name: "Ingenieros",
                    value: `${validatingData.squadNumber}`
                })
            }

            if (validatingData.executedDate && validatingData.originalFlow) {
                newSortActivitiesToUpload.push({
                    fieldId: `${act['Pozo']}-${validatingData.originalFlow?.id}-${validatingData.squadNumber}`,
                    locationId: act['locationId'],
                    originFlowId: validatingData.originalFlow?.id,
                    projectId: validatingData.projectId,
                    taskid: validatingData.activeTaskId,
                    users:users,
                    variables,
                    groupAssigned: validatingData.groupActivityId,
                })
            }       
        }

        setSortActivitiesToUpload(newSortActivitiesToUpload)

        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep(step))

        setUploadTaskWithVariables(true)
    }

    return (
        <>
            {(uploadTaskWithVariables)&& <UploadActivitiesModal
                executedDate={validatingData.executedDate}
                sortActivitiesToUpload={sortActivitiesToUpload}
                close={() => setUploadTaskWithVariables(false)}
            />}
            <div className='consolidate_files_container_info_container' >
                <div className="consolidate_files_container_header">
                    <div>Validar la Información antes de consolidar</div>
                    <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={onClose} />
                </div>
                <div className="consolidate_files_container_body">
                    <StatesTabs tabs={filterStates} setActiveState={setFilterStates} />
                    {filterStates.find(x => x.active)?.id === 'summary' &&
                        <GeneralTab validatingData={validatingData} handleOnChangeValidationData={handleOnChangeValidationData} squads={squads} sortsActivities={sortsActivities} />}
                    {filterStates.find(x => x.active)?.id === 'errors' && <ErrorList errors={errors} />}
                    {filterStates.find(x => x.active)?.id === 'activities' &&
                        <ActivitiesList
                            sortsActivities={sortsActivities}
                            errors={errors}
                        />}
                    {filterStates.find(x => x.active)?.id === 'files' &&
                        <ButtonsTab
                            onClickUploadActivities={onClickUploadActivities}
                            errors={errors}
                        />
                    }
                </div>
            </div>
        </>
    )
}
